import { useEffect, useState } from "preact/hooks";
import fetchProduct from "./fetchProduct";

/**
 *
 * @param handles [string] product handles
 * @returns [data] Array of products
 */
export default function useProducts(handles) {
  const [data, setData] = useState([]);
  const handlesString = handles.join(',');
  console.log(`handles`, handles);
  useEffect(() => {
    if (!handles.length) return;

    Promise.all(handles.map((handle) => fetchProduct(handle))).then(products => {

      setData(products.filter(product => product));
    });
  }, [handlesString, setData, fetchProduct]);

  return data;
}
